import { BuiltInPlan } from "../../lib/workout";

export default {
  id: "d05e8c67-0f5e-4478-b854-2c7486634744",
  title: "Hal Higdon: Advanced 1",
  raceType: "Marathon",
  units: "miles",
  workouts: [
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "3xhill", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "5 miles pace",
      totalDistance: 5,
    },
    {
      description: "10 miles",
      totalDistance: 10,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "30 tempo", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "5 miles pace",
      totalDistance: 5,
    },
    {
      description: "11 miles",
      totalDistance: 11,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "6 miles run",
      totalDistance: 6,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "4x800", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "6 miles pace",
      totalDistance: 6,
    },
    {
      description: "8 miles",
      totalDistance: 8,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "6 miles run",
      totalDistance: 6,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "4xhill", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "6 miles pace",
      totalDistance: 6,
    },
    {
      description: "13 miles",
      totalDistance: 13,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "7 miles run",
      totalDistance: 7,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "35 tempo", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "7 miles run",
      totalDistance: 7,
    },
    {
      description: "14 miles",
      totalDistance: 14,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "7 miles run",
      totalDistance: 7,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "5x800", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "7 miles pace",
      totalDistance: 7,
    },
    {
      description: "10 miles",
      totalDistance: 10,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "8 miles run",
      totalDistance: 8,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    { description: "5xhill", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "8 miles pace",
      totalDistance: 8,
    },
    {
      description: "16 miles",
      totalDistance: 16,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "8 miles run",
      totalDistance: 8,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    { description: "40 tempo", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "8 miles run",
      totalDistance: 8,
    },
    {
      description: "17 miles",
      totalDistance: 17,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "9 miles run",
      totalDistance: 9,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    { description: "6x800", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    { description: "Half Marathon", totalDistance: 13.1 },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    {
      description: "9 miles run",
      totalDistance: 9,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    { description: "6xhill", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "9 miles pace",
      totalDistance: 8,
    },
    {
      description: "19 miles",
      totalDistance: 19,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "10 miles run",
      totalDistance: 10,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "45 tempo", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "10 miles pace",
      totalDistance: 10,
    },
    {
      description: "20 miles",
      totalDistance: 20,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "6 miles run",
      totalDistance: 6,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "7x800", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "6 miles pace",
      totalDistance: 10,
    },
    {
      description: "12 miles",
      totalDistance: 12,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "10 miles run",
      totalDistance: 10,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "7xhill", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "10 miles pace",
      totalDistance: 10,
    },
    {
      description: "20 miles",
      totalDistance: 20,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "6 miles run",
      totalDistance: 6,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "45 tempo", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "6 miles run",
      totalDistance: 6,
    },
    {
      description: "12 miles",
      totalDistance: 12,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "10 miles run",
      totalDistance: 10,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "8x800", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "10 miles run",
      totalDistance: 10,
    },
    {
      description: "20 miles",
      totalDistance: 20,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    {
      description: "8 miles run",
      totalDistance: 8,
    },
    {
      description: "5 miles run",
      totalDistance: 5,
    },
    { description: "6xhill", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "4 miles pace",
      totalDistance: 4,
    },
    {
      description: "12 miles",
      totalDistance: 12,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "6 miles run",
      totalDistance: 6,
    },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    { description: "30 tempo", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "4 miles run",
      totalDistance: 4,
    },
    {
      description: "8 miles",
      totalDistance: 8,
    },
    {
      description: "3 miles run",
      totalDistance: 3,
    },
    { description: "4x400", totalDistance: 0 },
    {
      description: "2 miles run",
      totalDistance: 2,
    },
    { description: "Rest", totalDistance: 0 },
    { description: "Rest", totalDistance: 0 },
    {
      description: "2 miles run",
      totalDistance: 2,
    },
    { description: "Marathon", totalDistance: 26.2 },
  ],
} as BuiltInPlan;
